// import React from "react";
import { Modal, Image, Badge } from "react-bootstrap";
import moment from "moment";

const BlogsModal = ({ show, handleClose, payload = {} }) => {
  let blog = {};
  blog = payload;
  // console.log(blog);

  if (!blog) return null;

  const { cover_img, title, content, tags = [], createdAt } = blog;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      scrollable
      contentClassName="p-0"
    >
      <Modal.Header closeButton className="border-bottom-0 pb-0">
        <Modal.Title className="fs-5">{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-0">
        {cover_img && (
          <Image
            src={cover_img}
            alt={title}
            fluid
            className="w-100"
            style={{ maxHeight: "300px", objectFit: "cover" }}
          />
        )}

        <div className="p-4">
          <div className="d-flex justify-content-between align-items-center text-muted mb-2">
            <small>{moment(createdAt).format("MMM D, YYYY")}</small>
            <div>
              {tags.map((tag, i) => (
                <Badge key={i} bg="secondary" className="me-1">
                  {tag}
                </Badge>
              ))}
            </div>
          </div>

          <div
            className="blog-content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BlogsModal;
